import { makeSceneDoc } from '../kit.js';

/**
 * 衙前广场：体面与规矩的中心。
 * 衙门大堂在这里办证，药铺隔着广场开，榜文每日一换。
 */
export const yamenSqDoc = makeSceneDoc({
  id: 'yamen_sq',
  name: '衙前广场',
  region: 'city',
  tier: 2,
  node: 'yamen_sq',
  desc: '石砖铺得平平整整，说话声都不自觉小了些。',
  w: 44, h: 26,
  fill: 'o',
  spawn: { gx: 3, gy: 14 },
  draw(b, rng) {
    b.rect(0, 0, 44, 26, 'o');
    b.rect(0, 0, 4, 26, ',');
    b.rect(40, 0, 4, 26, ',');
    // 木地板只铺房子坐的那几格，门前留一格门槛，别让人绕到屋后头去
    b.rect(20, 6, 5, 3, '.');      b.set(22, 9, '+');    // 衙门
    b.rect(21, 21, 3, 2, '.');     b.set(22, 23, '+');   // 药铺
    b.hline(14, 29, 10, '=');
    b.rect(6, 11, 8, 5, ',');
    b.rect(30, 11, 8, 5, ',');
  },
  props: [
    { type: 'government_office', gx: 26, gy: 8 },
    { type: 'license_office', gx: 18, gy: 9 },
    { type: 'notice_board', gx: 26, gy: 11 },
    { type: 'incense_burner', gx: 22, gy: 13 },
    { type: 'water_well', gx: 34, gy: 14 },
    { type: 'herb_basket', gx: 12, gy: 16 },
    { type: 'medical_book_pile', gx: 31, gy: 16 },
  ],
  portals: [
    { to: 'gate', gx: 1, gy: 14, spawn: [41, 16], label: '城门口' },
    { to: 'main_street', gx: 42, gy: 20, spawn: [45, 14], label: '主街' },
    { to: 'yamen_hall', gx: 22, gy: 9, spawn: [8, 14], label: '衙门大堂' },
    { to: 'pharmacy', gx: 22, gy: 23, spawn: [6, 13], label: '药铺' },
  ],
});

export default yamenSqDoc;
